import { useEffect, useState } from "react";
import history, { BrowserHistoryEvent } from "web/script/utils/history";

export function useHistoryWatcher(): BrowserHistoryEvent | null {
    let [urlData, setUrlData] = useState(null);
    useEffect(() => {
        function handler(event, data): void {
            setUrlData(data);
        }
        history.on("change", handler);
        return (): void => {
            history.off("change", handler);
        };
    }, []);
    return urlData;
}
